import MemoriesEditor from 'src/common/components/memories/MemoriesEditor';

export default function AdvisorMemoriesSection() {
  return (
    <MemoriesEditor
      title="My memories"
      description="These are your personal memories used by the AI to personalise conversations and documents. They are private to you and not shared with other advisers."
      emptyText="No memories saved yet. Memories are created automatically during conversations with the AI."
      queryKey={['memories', 'advisor']}
      apiEndpoint="/memories/advisor"
    />
  );
}
